import { AuthentificationEndpoints } from "../../Routes/api/Endpoints";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { apiUrlCat } from "../../Routes/api/global_vars";
import { logout, selectToken, setAccessToken, setRefreshToken } from "../features/userSliceWithTokenValidation";

const apiUrlCat = process.env.REACT_APP_API_URL_CATEGORIE;

const baseQuery = fetchBaseQuery({
    baseUrl: apiUrlCat,
    prepareHeaders: (headers, { getState }) => {
        const token = selectToken(getState());
        if (token) {
            headers.set("Authorization", `Bearer ${token}`);
        }
        return headers;
    },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result?.error?.status === 401) {
        const refreshToken = api.getState().auth.refreshToken;

        if (refreshToken) {
            const refreshResult = await baseQuery(
                {
                    url: AuthentificationEndpoints.refreshToken,
                    method: "POST",
                    body: { refresh: refreshToken },
                },
                api,
                extraOptions
            );

            if (refreshResult?.data) {
                const newAccessToken = refreshResult.data.access;
                const newRefreshToken = refreshResult.data.refresh;

                api.dispatch(setAccessToken(newAccessToken));
                api.dispatch(setRefreshToken(newRefreshToken));

                result = await baseQuery(args, api, extraOptions);
            } else {
                api.dispatch(logout());
            }
        } else {
            api.dispatch(logout());
        }
    }

    return result;
};

export const API = createApi({
    baseQuery: baseQueryWithReauth,
    refetchOnReconnect: true,
    keepUnusedDataFor: 60000,
    reducerPath: "api",
    endpoints: () => ({}),
});

export const TAGS = [
    "Projects",
    "Notifications",
    "Categories",
    "Taches",
    "Criteria",
];

export const ApiMananger = API.enhanceEndpoints({
    addTagTypes: [...TAGS],
});